<template>
  <div class="home-page">
    <div class="home-overlay">
      <h1>大理市定点医药机构<br>分布图</h1>

      <div class="home-actions">
        <router-link
          class="home-card"
          :to="{ name: 'map', query: { source: 'pharmacies' } }"
        >
          <span class="home-card__button">
            <img class="home-card__icon-image" :src="pharmacyIcon" alt="">
            <span>定点零售药店</span>
          </span>
        </router-link>

        <router-link
          class="home-card"
          :to="{ name: 'map', query: { source: 'institutions' } }"
        >
          <span class="home-card__button">
            <img class="home-card__icon-image" :src="institutionIcon" alt="">
            <span>定点医疗机构</span>
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import institutionIcon from '../assets/jigou.svg'
import pharmacyIcon from '../assets/yaodian.svg'

export default {
  name: 'HomeView',
  data() {
    return {
      institutionIcon,
      pharmacyIcon
    }
  }
}
</script>

<style>
.home-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.94), rgba(226, 238, 255, 0.9)),
    radial-gradient(circle at top right, rgba(109, 160, 255, 0.18), transparent 32%),
    linear-gradient(125deg, rgba(88, 144, 255, 0.08) 10%, transparent 10.5%, transparent 32%, rgba(88, 144, 255, 0.08) 32.5%, rgba(88, 144, 255, 0.08) 52%, transparent 52.5%);
}

.home-overlay {
  width: min(1120px, calc(100% - 48px));
  text-align: center;
}

.home-overlay h1 {
  margin: 0 0 78px;
  color: #0b4db8;
  font-size: clamp(52px, 7vw, 96px);
  line-height: 1.22;
  text-shadow: 0 8px 16px rgba(11, 77, 184, 0.22);
}

.home-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 64px;
  justify-content: center;
}

.home-card {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 132px;
  padding: 20px 24px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 18px 40px rgba(16, 38, 63, 0.12);
  color: #fff;
  text-decoration: none;
}

.home-card__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-width: 320px;
  height: 88px;
  padding: 0 28px;
  border-radius: 14px;
  background: linear-gradient(135deg, #2f81ff, #5aa0ff);
  box-shadow: 0 12px 24px rgba(47, 129, 255, 0.22);
}

.home-card__button span {
  font-size: clamp(28px, 2.5vw, 42px);
  font-weight: 700;
}

.home-card__icon-image {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
}

@media (max-width: 960px) {
  .home-actions {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .home-card__button {
    min-width: 0;
    width: 100%;
  }

  .home-card__button span {
    font-size: 30px;
  }
}
</style>
